<template>
<div class="scroll">
    <div class="image-small">
        <div class="searchBox">
            <el-input v-model="param.materialname" placeholder="输入关键字"></el-input>
            <el-button @click="triggerBlur">搜索</el-button>
        </div>
        <div class="listBox">
            <div class="leftBar">
                <div class="item" @click="changeBar(index)" :class="{'active': selectbarIndex === index}" v-for="(item, index) in leftBarList" :key="index">{{item.catename}}</div>
            </div>
            <div class="rightList">
                <div class="list" v-if="flieList.length">
                    <div class="item" @click="selectItem(index)" v-for="(item, index) in flieList" :key="index">
                        <img :src="item.coveratturl" class="coveratturl" alt="">
                        <p class="name">{{item.name}}</p>
                        <img class="active" :src="require('@/common/images/other/Shape@2x.png')" v-if="selectItemIndex !== index" alt="">
                        <img class="active" :src="require('@/common/images/other/Shape2@2x.png')" v-else alt="">
                    </div>
                </div>
                <div class="pageBox" v-for="(item, index) in leftBarList" :key="index" v-show="index === selectbarIndex && flieList.length">
                    <page :ref="`page${index}`" :total="page.rowCount" @getList="getItemList" />
                </div>
                <div class="noData" v-if="!flieList.length">
                    <img :src="require('@/common/images/other/zwsj@2x.png')" alt="">
                    <p>暂无素材</p>
                </div>
            </div>
        </div>
        <!-- <span class="btn" :class="[isLeft?'tc-blue':'']" @click="prev"><i class="el-icon-arrow-left"></i></span>
        <div class="image-list">
            <div class='image-list-inner' ref="flieListInner" v-if="uploadType.datatype == 'IMAGE'">
                <img :class="[index==0 ? 'is-active' : '']" v-lazy="item.coveratturl" alt="" v-for="(item,index) in flieList" :key="index"
                     @click="selectedImage($event,item)" >
            </div>
            <div class='image-list-inner' ref="flieListInner"  v-if="uploadType.datatype == 'VIDEO'">
                <img :class="[index==0 ? 'is-active' : '']" v-lazy="item.coveratturl" alt="" v-for="(item,index) in flieList" :key="index"
                     @click="selectedImage($event,item)" >
            </div>
        </div>
        <span class="btn" :class="[isRight?'tc-blue':'']" @click="next"><i class="el-icon-arrow-right"></i></span> -->
    </div>
</div>
</template>

<script>
import $ from 'jquery'
import {findAllImage, findAllVideo} from 'api/materialMgtApi'
import {mapGetters, mapActions} from 'vuex'
import page from '../page/page3.vue'
export default {
    name: 'scroll',
    data() {
        return {
            fileInfo: {},
            flieList: [],
            left: 0,
            isLeft: false,
            isRight: true,
            page: {
                page: 1,
                pageSize: 10,
                rowCount: 0,
                pageCount: 0
            },
            fileOtherInfo: {
                type: 'add',
                keyid: '',
                vsource: 2 // 1自己上传 2素材 3系统默认资源
            },
            scrollWitch: 500,
            param: {
                catalogInnerId: '', // 图片分类的innerid
                materialname: ''
            },
            leftBarList: [],
            selectbarIndex: 0,
            selectItemIndex: 0
        }
    },
    mounted() {

    },
    props: ['uploadType'],
    methods: {
        triggerBlur() {
            this.page.page = 1
            this.leftBarList.forEach((obj, index) => {
                this.$refs[`page${index}`][0].pagination.page = 1
            })
            if (this.uploadType.datatype === 'IMAGE') {
                this._getImageList()
            } else {
                this._getVideoList()
            }
        },
        getItemList(page) {
            console.log(555)
            this.page.page = page.page
            if (this.uploadType.datatype === 'IMAGE') {
                this._getImageList()
            } else {
                this._getVideoList()
            }
        },
        changeBar(index) {
            if (index !== this.selectbarIndex) {
                this.selectItemIndex = 0
                this.selectbarIndex = index
                this.param.catalogInnerId = this.leftBarList[index].catalogid
                this.page.page = 1
                console.log(this.$refs)
                this.$refs[`page${this.selectbarIndex}`][0].pagination.page = 1
                this._getList()
            }
        },
        selectItem(index) {
            if (index !== this.selectItemIndex) {
                this.selectItemIndex = index
                this.fileOtherInfo.keyid = this.flieList[index].innerid
                this.fileInfo = Object.assign({}, JSON.parse(this.flieList[index].info), this.fileOtherInfo)
                this.$emit('saveFile', this.fileInfo)
            }
        },
        // 选择文件
        selectedImage(e, obj) {
            this.fileOtherInfo.keyid = obj.innerid
            this.fileInfo = Object.assign({}, JSON.parse(obj.info), this.fileOtherInfo)
            $(e.target).addClass('is-active').siblings().removeClass('is-active')
            console.log(this.fileInfo)
            this.$emit('saveFile', this.fileInfo)
        },
        prev() {
            this.left = this.$refs.flieListInner.style.left ? parseInt(this.$refs.flieListInner.style.left) : 0
            if (!this.left) {
                return false
            }
            this.isRight = true
            if (this.left >= -this.scrollWitch) {
                this.$refs.flieListInner.style.left = `0`
                this.isLeft = false
            } else {
                this.page.page--
                this.$refs.flieListInner.style.left = `${this.left + this.scrollWitch}px`
            }
        },
        next() {
            if (!this.isRight) {
                return false
            }
            let width = this.flieList.length * 100
            this.left = this.$refs.flieListInner.style.left ? parseInt(this.$refs.flieListInner.style.left) : 0
            this.isLeft = true
            if ((this.page.pageCount === this.page.page)) {
                this.isRight = false
                this.$refs.flieListInner.style.left = `${-width + this.scrollWitch}px`
            } else {
                this.page.page++
                if (width + this.left <= this.scrollWitch) {
                    this._getList()
                }
                this.$refs.flieListInner.style.left = `${this.left - this.scrollWitch}px`
            }
        },
        getList(pageSize, innerid) {
            console.log(pageSize)
            // if (!this.flieList.length) {
            this.page.pageSize = pageSize
            this.page.page = 1
            this.scrollWitch = pageSize * 100
            this.param.catalogInnerId = innerid
            this.flieList = []
            this._getList()
            // }
        },
        _getList() {
            if (this.uploadType.datatype === 'IMAGE') {
                this._getImageList()
            } else {
                this._getVideoList()
            }
        },
        _getImageList() {
            // console.log('this.param',this.param)
            findAllImage({
                data: Object.assign({}, this.page, this.param),
                success: data => {
                    console.log(data.data)
                    if (this.page.page === 1) {
                        this.leftBarList = data.data.cataloglist
                        data.data.cataloglist.forEach(obj => {
                            if (!obj.page) {
                                obj.page = {
                                    page: 1,
                                    pageSize: 10
                                }
                            }
                        })
                    }
                    this.flieList = data.data.content
                    // this.flieList = this.flieList.concat(data.data)
                    this.page.rowCount = data.data.pageinfo.rowCount
                    this.page.pageCount = data.data.pageinfo.pageCount
                    this.selectItemIndex = 0
                    if (this.flieList.length) {
                        this.fileOtherInfo.keyid = this.flieList[this.selectItemIndex].innerid
                        this.fileInfo = Object.assign({}, JSON.parse(this.flieList[this.selectItemIndex].info), this.fileOtherInfo)
                        this.$emit('saveFile', this.fileInfo)
                    } else {
                        this.$emit('saveFile', {})
                    }
                    // if (this.page.pageSize >= data.pageableData.rowCount) {
                    //     this.isRight = false
                    //     this.isLeft = false
                    // } else {
                    //     this.isRight = true
                    // }
                    // if (this.page.page >= data.pageableData.pageCount) {
                    //     this.isRight = false
                    // }
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                }
            })
        },
        _getVideoList() {
            findAllVideo({
                data: Object.assign({}, this.page, {hostinnerid: this.user.hostinnerid}, this.param),
                success: data => {
                    if (this.page.page === 1) {
                        this.leftBarList = data.data.cataloglist
                        data.data.cataloglist.forEach(obj => {
                            if (!obj.page) {
                                obj.page = {
                                    page: 1,
                                    pageSize: 10
                                }
                            }
                        })
                    }
                    this.flieList = data.data.content
                    this.page.rowCount = data.data.pageinfo.rowCount
                    this.page.pageCount = data.data.pageinfo.pageCount
                    this.selectItemIndex = 0
                    if (this.flieList.length) {
                        this.fileOtherInfo.keyid = this.flieList[this.selectItemIndex].innerid
                        this.fileInfo = Object.assign({}, JSON.parse(this.flieList[this.selectItemIndex].info), this.fileOtherInfo)
                        this.$emit('saveFile', this.fileInfo)
                    } else {
                        this.$emit('saveFile', {})
                    }
                    // this.flieList = this.flieList.concat(data.data)
                    // this.page.rowCount = data.pageableData.rowCount
                    // this.page.pageCount = data.pageableData.pageCount
                    // if (this.page.pageSize >= data.pageableData.rowCount) {
                    //     this.isRight = false
                    //     this.isLeft = false
                    // } else {
                    //     this.isRight = true
                    // }
                    // if (this.page.page >= data.pageableData.pageCount) {
                    //     this.isRight = false
                    // }
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                }
            })
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'loading',
            'user'
        ])
    },
    components: {
        page
    },
    deactivated() {
        this.$destroy()
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/mixin";
@import "~common/scss/variable";
.scroll {
    .image-small{
        // @include flexBox(space-between);
        .searchBox {
            @include flexBox(space-between);
            align-items: center;
            margin-bottom: 20px;
            padding: 0 20px;
            .el-input {
                flex: 1;
                margin-right: 30px;
            }
            .el-button {
                width: 96px;
                height: 36px;
                margin: 0;
            }
        }
        .listBox {
            display: flex;
            border-top: 1px solid #DCDFE6;
            border-bottom: 1px solid #DCDFE6;
            .leftBar {
                width: 240px;
                border-right: 1px solid #DCDFE6;
                max-height: 358px;
                box-sizing: border-box;
                // margin-bottom: 10px;
                overflow-y: scroll;
                overflow-x: hidden;
                .item {
                    line-height: 40px;
                    padding-left: 16px;
                    width: 228px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    border-left: 4px solid #fff;
                    box-sizing: border-box;
                    cursor: pointer;
                    &.active {
                        background: #E6F1FC;
                        border-color: #409EFF;
                        color: #409EFF;
                    }
                    &:hover {
                        background: #E6F1FC;
                        color: #409EFF;
                        border-color: #409EFF;
                    }
                }
            }
            .rightList {
                flex: 1;
                .list {
                    display: flex;
                    // align-items: center;
                    flex-wrap: wrap;
                    padding: 10px 8px 0px 18px;
                    height: 358px;
                    box-sizing: border-box;
                    // margin-bottom: 10px;
                    overflow-y: scroll;
                    .item {
                        margin-bottom: 20px;
                        position: relative;
                        cursor: pointer;
                        &:not(:nth-of-type(3n)) {
                            margin-right: 20px;
                        }
                        .coveratturl {
                            width: 146px;
                            height: 82px;
                            margin-bottom: 12px;
                        }
                        .active {
                            width: 18px;
                            height: 18px;
                            position: absolute;
                            top: 10px;
                            left: 10px;
                        }
                        .name {
                            width: 146px;
                            font-size: 14px;
                            text-overflow: -o-ellipsis-lastline;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            display: -webkit-box;
                            -webkit-line-clamp: 2;
                            line-clamp: 2;
                            -webkit-box-orient: vertical;
                            line-height: 20px;
                        }
                    }
                }
                .pageBox {
                    margin-bottom: 10px;
                }
                .noData {
                    height: 358px;
                    text-align: center;
                    color: #909399;
                    img {
                        margin: auto;
                        margin-bottom: 10px;
                        width: 372px;
                        height: 269px;
                    }
                }
            }
        }
        // .btn{
        //     width: 30px;
        //     font-size: 30px;
        //     font-weight: 600;
        // }
        // .image-list{
        //     flex-grow: 1;
        //     height: 60px;
        //     overflow: hidden;
        //     margin: auto;
        //     position: relative;
        //     .image-list-inner{
        //         transition: all 1s;
        //         left: 0;
        //         position: absolute;
        //         @include flexBox(flex-start);
        //         img,video{
        //             box-sizing: border-box;
        //             width: 90px;
        //             height: 60px;cursor: pointer;
        //             padding: 2px;
        //         }
        //         img + img{
        //             margin-left: 10px;
        //         }
        //         img.is-active{
        //             border: 1px solid $line;
        //         }
        //     }
        // }
    }
}
</style>
